import { render, staticRenderFns } from "./Package.html?vue&type=template&id=e246b820&external"
import script from "./Package.js?vue&type=script&lang=js&external"
export * from "./Package.js?vue&type=script&lang=js&external"
import style0 from "./Package.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports